import { allToolsProductList, stepProductId } from "../../../globalConstants";

export const redirectToProduct = (url: any) => {
    window.location = url;
}

export const getSkillOrLevelIndexString = (productID: any) => {
  if(productID == "18" || productID == "29"){
    return "navbar_skill_index";
  } else {
    return "navbar_level_index";
  }
}

export const frameProductURL = (productID: any) => {
    return !sessionStorage.getItem("isDemoUser") ? process.env[`REACT_APP_PRODUCT_URL_ID_${productID}`] : process.env[`REACT_APP_PRODUCT_URL_ID_18`]
}

export const skillorLevelIndexUrl = (productID: any) => {
    if(productID == "18" || productID == "29"){
      return `${frameProductURL(productID)}/skillsindex`
    } else {
      return `${frameProductURL(productID)}/levelindex`
    }
  }

export const getBaseName = () => {
  let url = window.location.href;
  let splitUrl = url.split("/");
  return splitUrl[3].toString();
};

export const capitalize = (s: any) => {
  if (typeof s !== "string") return "";
  s = s.toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export function checkForIntercept(allInfo: any, props: any, setIsIntercept: any) {
  if ((location.pathname !== "/welcome" && !allInfo.common.managerEmail && allInfo.common.isManagerEmailRequired) ||
      (sessionStorage.getItem("RenwalIntercept") === "true" && allInfo.common.isRenewalInterceptRequired) ||
      (props.isInterceptEnabled || location.pathname === "/intercept") ||
      (!localStorage.getItem("cultureCenterSelected") && props.cultureCenterIntercept)) { 
        setIsIntercept(true); 
      } else { 
          setIsIntercept(false); 
      }
  }
export const toolsToShow = (productId:string) => {
  return allToolsProductList.includes(productId)
}

export const hideToolsMenu = (productId:string) =>{
  return stepProductId.includes(productId)
}